import React, { useState, useEffect, useRef } from 'react';
import { Icon, IconClose } from '../../../base/icons';
import { getLJsonStorage } from '../../welcome-dashboard/Utils';

// css metronome
import './metronome.css';
import { ct } from '../../constant-Utils';

var timeoutId = 0;
var oneMin = 60000;
var turnedOn = false;
var beatCount = 1;

const Metronome = (props) => {
	const { socket, Sessions, closeTool, toolOpenLocal } = props;
	const beepElement = useRef(1);
	const { openByUser, SessionId } = Sessions;

	// setting default beat
	const [defaultBeat, setBeat] = useState({
		bpm: 100,
		bpb: 4
	});

	// hide buttons and cross buttons
	const [isDisable, setIsDisable] = useState(false);


	// useEffect(() => {
	// 	console.log("change is disabled ", isDisable, "dasdasdas ", props)
	// }, [isDisable])

	// setting the audio stream
	useEffect(() => {

		if (SessionId !== openByUser) {
			setIsDisable(true);

			// socket.on("metroreturn", (data) => {
			// 	const { room, metronomeData } = data;

			// 	if (room === window.location.href) {
			// 		const { bpm, bpb } = metronomeData;

			// 		// setting the beat to html
			// 		beatCount = metronomeData.beatCount;

			// 		// beep sound for the another users
			// 		if (beatCount === 1) {
			// 			barBeep();
			// 		} else {
			// 			beep();
			// 		}

			// 		beepElement.current = beatCount;

			// 		setBeat({
			// 			bpm,
			// 			bpb
			// 		});
			// 	}
			// });
		} else {
			setIsDisable(false);

			stop();
		}

		return function cleanup() {
			clearTimeout(timeoutId);
			// unsubscribe the listener
			// socket.off('metroreturn');
		};
	}, [openByUser]);

	// changes in beat
	const beatChange = (e) => {
		const { name, value } = e.target;
		if (isDisable) {
			return;
		}

		// setting metnome
		setBeat({
			...defaultBeat,
			[name]: value
		});
	}

	// Action buttons
	const beatAction = (field, actionType) => {
		const currentValue = parseFloat(defaultBeat[field]);

		if (actionType === 'minus') {
			// minus button
			setBeat({
				...defaultBeat,
				[field]: currentValue - 1
			});
		} else {
			setBeat({
				...defaultBeat,
				[field]: currentValue + 1
			});
		}
	}

	// start
	const start = () => {
		if (turnedOn) {
			return false;
		}
		beat();
		turnedOn = true;
		document.getElementById("start").setAttribute("disabled", "disabled");
		document.getElementById("bpmPlus").setAttribute("disabled", "disabled");
		document.getElementById("bpmMinus").setAttribute("disabled", "disabled");
		document.getElementById("bpm").setAttribute("disabled", "disabled");
		document.getElementById("bpbPlus").setAttribute("disabled", "disabled");
		document.getElementById("bpbMinus").setAttribute("disabled", "disabled");
		document.getElementById("bpb").setAttribute("disabled", "disabled");
		document.getElementById("stop").removeAttribute("disabled");
	};

	const stop = () => {
		clearTimeout(timeoutId);
		turnedOn = false;

		if (document.getElementById("bpmPlus")) {
			document.getElementById("bpmPlus").removeAttribute("disabled");
			document.getElementById("bpmMinus").removeAttribute("disabled");
			document.getElementById("bpm").removeAttribute("disabled");
			document.getElementById("bpbPlus").removeAttribute("disabled");
			document.getElementById("bpbMinus").removeAttribute("disabled");
			document.getElementById("bpb").removeAttribute("disabled");
			document.getElementById("start").removeAttribute("disabled");
			document.getElementById("stop").setAttribute("disabled", "disabled");
		}
	};

	function beat() {
		const { bpm, bpb } = defaultBeat;

		timeoutId = setTimeout(beat, (oneMin / bpm));
		document.getElementById("beatIndicator").innerHTML = beatCount;

		// setTimeout(function () {
		if (beatCount === 1) {
			barBeep();
		}
		else {
			beep();
		}
		// }, 100)

		// student can able to send to techer
		// socket.emit('metronomestart', {
		// 	room: window.location.href,
		// 	metronomeData: {
		// 		beatCount,
		// 		bpm,
		// 		bpb
		// 	},
		// });

		beatCount++;

		if (beatCount > bpb) {
			beatCount = 1;
		}

		// emit data for newly opened user
		// socket.emit("openTools_fromtool", {
		// 	openTool: 'metronome',
		// 	SessionId: openByUser,
		// 	location: window.location.href
		// });
	};

	function beep() {
		// 2, 3, 4
		const beatIndicator = document.getElementById("beatIndicator");

		beatIndicator.classList.add("beep");
		beatIndicator.classList.remove("barBeep");
		
		var snd2 = new Audio("data:audio/wav;base64,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");
		snd2.play();

		// document.getElementById('beepOne').play();


	};

	function barBeep() {
		// 1
		const beatIndicator = document.getElementById("beatIndicator");

		beatIndicator.classList.add("barBeep");
		beatIndicator.classList.remove("beep");
		// document.getElementById('beepTwo').play();


		var snd1 = new Audio("data:audio/wav;base64,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");
		snd1.play();

		// document.getElementById('beepTwo').play();

	};

	const isGuestAccount = getLJsonStorage("auth", "guest_id");

	return (
		<div className="metrono-outer">
			<div id="metronome">
				{isGuestAccount ? "" : <div
					className='close-side-bar'
					id='metronome-close-icon-wrapper'
					onClick={closeTool}>
					<Icon containerId='metronome-close-icon' src={IconClose} />
				</div>}
				<div id="metronomeBg">
					<div className="beatwrapper">
						<div id="beatBarContainer">
							<div id="beatBar">&nbsp;</div>
						</div>
						<br />
						<div id="beatIndicatorContainer">
							<div id="beatIndicator" className="beep">{beepElement.current}</div>
						</div>
						<div id="settingsContainer" >
							<div id="settings" className="row setting">
								<div className="col-sm-6 start">
									<label>{ct("rta-trmc.tools.beatsPerMinute")}:</label>
									<input type="text" name="bpm" id="bpm" onChange={beatChange} value={defaultBeat.bpm} style={{ width: "60px", paddingLeft: "11px" }} />
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpm', 'plus')} name="bpmPlus" id="bpmPlus" className="plusMinus" value="+" />
									}
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpm', 'minus')} name="bpmMinus" id="bpmMinus" className="plusMinus" value="-" />
									}
									{(!isDisable || toolOpenLocal) &&

										<input type="button" onClick={start} name="start" id="start" value={ct("rta-trmc.tools.startBtn")} />
									}
								</div>
								<div className="col-sm-6 stop">
									<label>{ct("rta-trmc.tools.beatsPerBar")}:</label>
									<input type="text" name="bpb" onChange={beatChange} id="bpb" value={defaultBeat.bpb} style={{ width: "60px", paddingLeft: "11px" }} />
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpb', 'plus')} name="bpbPlus" id="bpbPlus" className="plusMinus" value="+" />
									}
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={() => beatAction('bpb', 'minus')} name="bpbMinus" id="bpbMinus" className="plusMinus" value="-" />
									}
									{(!isDisable || toolOpenLocal) &&
										<input type="button" onClick={stop} name="stop" id="stop" value={ct("rta-trmc.tools.stopBtn")} />
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="audioHide">
				<audio id="beepOne" src="sounds/beep-7.wav" preload="auto" controls="controls">{ct("rta-trmc.tools.standardsBrowers")}</audio>
				<audio id="beepTwo" src="sounds/beep-8.wav" preload="auto" controls="controls">{ct("rta-trmc.tools.standardsBrowers")}</audio>
			</div>
		</div>
	);
}

export default Metronome;
